// extracted by mini-css-extract-plugin
module.exports = {"some-links-block":"SoMeLinksBlock_some-links-block__UN3Ai","some-links-block__item":"SoMeLinksBlock_some-links-block__item__a9PnA"};